import { render, staticRenderFns } from "./AvailableDiscounts.vue?vue&type=template&id=70022da8&scoped=true"
import script from "./AvailableDiscounts.vue?vue&type=script&lang=ts"
export * from "./AvailableDiscounts.vue?vue&type=script&lang=ts"
import style0 from "./AvailableDiscounts.vue?vue&type=style&index=0&id=70022da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70022da8",
  null
  
)

export default component.exports